// extracted by mini-css-extract-plugin
export default {"ErrorMessage":"ErrorMessage_ErrorMessage__4bPIT","ErrorMessage__Icon":"ErrorMessage_ErrorMessage__Icon__IvV0+"};